/**
 * Hariom ERP - Sales & CRM stores (persisted, start empty).
 * Leads and Sales Orders are entered by the sales team.
 */
import { createCrudStore } from './createCrudStore'

export interface Lead {
  id: string
  company: string
  contact: string
  phone: string
  city: string
  product: string
  estTon: number
  status: string   // new | contacted | qualified | proposal | negotiation | won | lost
  assigned: string
  followUp: string
}

export interface SalesOrder {
  id: string
  orderNo: string
  customer: string
  items: string
  amount: number
  status: string   // draft | confirmed | processing | shipped | delivered | cancelled
  date: string
}

export const useLeadStore = createCrudStore<Lead>('hariom-erp-leads')
export const useSalesOrderStore = createCrudStore<SalesOrder>('hariom-erp-sales-orders')
